import GroupEditor from './groupsEditor';

export default GroupEditor;
